import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

export const markLeadAsReadById = createAsyncThunk(
    "leads/markLeadAsReadById",
    async (_id, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.put(`${BackendURL}/leads/read-lead/${_id}`);
            return res.data.lead; 
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const markAllLeadsAsRead = createAsyncThunk(
    "leads/markAllLeadsAsRead",
    async (_, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.put(`${BackendURL}/api/leads/readall-lead`);
            return res.data; // matchedCount & modifiedCount
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const leadsReadSlice = createSlice({
    name: "leadsRead",
    initialState: {
        leads: [],      // holds updated leads after marking read
        loading: false,
        error: null,
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(markLeadAsReadById.pending, (state) => {
                state.loading = true;
            })
            .addCase(markLeadAsReadById.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;

                const updated = action.payload;
                state.leads = state.leads.map((lead) =>
                    lead._id === updated._id ? updated : lead
                );
            })
            .addCase(markLeadAsReadById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        builder
            .addCase(markAllLeadsAsRead.pending, (state) => {
                state.loading = true;
            })
            .addCase(markAllLeadsAsRead.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
                state.leads = state.leads.map((lead) => ({
                    ...lead,
                    isRead: true,
                }));
            })
            .addCase(markAllLeadsAsRead.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default leadsReadSlice.reducer;
